import request from "@/utils/request";

export function queryTask(page, size, data) {
  return request({
    url: "/sys/taskInfo/queryTasks?page=" + page + "&size=" + size,
    method: "post",
    data,
  });
}

export function addTask(data) {
  return request({
    url: "/sys/taskInfo/addTask",
    method: "post",
    data,
  });
}

export function getTask(id) {
  return request({
    url: "/sys/taskInfo/getOneTask/" + id,
    method: "get",
  });
}

export function getTaskDetail(id) {
  return request({
    url: "/sys/taskInfo/getTaskDetail/" + id,
    method: "get",
  });
}

export function updateTask(data) {
  return request({
    url: "/sys/taskInfo/updateTask",
    method: "post",
    data,
  });
}

export function updateTaskCjTime(data) {
  return request({
    url: "/sys/taskInfo/updateTaskTime",
    method: "post",
    data,
  });
}

export function deleteTask(data) {
  return request({
    url: "/sys/taskInfo/deleteTasks",
    method: "post",
    data,
  });
}

export function getTaskPeriodById(id) {
  return request({
    url: "/sys/taskTimePeriod/getTaskPeriodById/" + id,
    method: "get",
  });
}

export function addTaskTime(data) {
  return request({
    url: "/sys/taskTimePeriod/addTaskTime",
    method: "post",
    data,
  });
}

export function getTaskTime(id) {
  return request({
    url: "/sys/taskTimePeriod/getOneTaskTime/" + id,
    method: "get",
  });
}

export function updateTaskTime(data) {
  return request({
    url: "/sys/taskTimePeriod/updateTaskTime",
    method: "post",
    data,
  });
}

export function deleteTaskTime(data) {
  return request({
    url: "/sys/taskTimePeriod/deleteTaskTimes",
    method: "post",
    data,
  });
}

// 任务转散拍使用独立接口，避免触发原取消任务的订单处理。
export function convertTaskToCasualPhoto(taskId) {
  return request({
    url: "/sys/taskInfo/convertToCasualPhoto/" + taskId,
    method: "post",
  });
}

export function getTaskCode() {
  return request({
    url: "/sys/taskInfo/getTaskCode",
    method: "get",
  });
}

/** 查询指定任务当前的任务代码、比对报告和采集码设置。 */
export function getTaskSettings(taskId) {
  return request({
    url: "/sys/taskInfo/getTaskSettings/" + taskId,
    method: "get",
  });
}

/** 沿用原接口，仅提交任务代码、比对报告和采集码设置。 */
export function updateTaskCode(data) {
  return request({
    url: "/sys/taskInfo/updateTaskCode",
    method: "post",
    data,
  });
}

export function getTaskStatistics() {
  return request({
    url: "/sys/taskTimePeriod/getTaskStatistics",
    method: "get",
  });
}

export function batchSave(taskId, data) {
  return request({
    url: "/sys/taskTimePeriod/batchSave/" + taskId,
    method: "post",
    data,
  });
}

export function savePhotographer(data) {
  return request({
    url: "/sys/taskInfo/savePhotographer",
    method: "post",
    data,
  });
}

export function setTaskStatus(taskId, status) {
  return request({
    url: "/sys/taskInfo/setTaskStatus?taskId=" + taskId + "&status=" + status,
    method: "post",
  });
}

export function packageXp(data) {
  return request({
    url: "/sys/taskInfo/packageXpNew",
    method: "post",
    data,
  });
}

// 查询任务内摄影师的扫码、异步上传及订单当前状态汇总。
export function queryCollectOperationPhotographers(taskId) {
  return request({
    url: "/sys/collectOperation/task/" + taskId + "/photographers",
    method: "get",
  });
}

// 查询任务维度的扫码、补单、异步上传及订单当前状态总览。
export function queryCollectOperationTaskSummary(taskId) {
  return request({
    url: "/sys/collectOperation/task/" + taskId + "/summary",
    method: "get",
  });
}

// 查询某摄影师在任务内操作过的订单，可按异常类型筛选。
export function queryCollectOperationOrders(taskId, photographerId, params) {
  return request({
    url:
      "/sys/collectOperation/task/" +
      taskId +
      "/photographers/" +
      photographerId +
      "/orders",
    method: "get",
    params,
  });
}

// 查询订单所有摄影师的异步上传文件明细，用于预览和追溯。
export function queryCollectOperationUploadFiles(taskId, orderId) {
  return request({
    url:
      "/sys/collectOperation/task/" +
      taskId +
      "/orders/" +
      orderId +
      "/uploads",
    method: "get",
  });
}
/**
 * 获取所有任务列表
 * @param {*} data
 * @returns
 */
export function queryAllTask() {
  return request({
    url: "/sys/taskInfo/queryAllTask",
    method: "get",
  });
}
/**
 * 添加任务标识
 * @param {*} data
 * @returns
 */
export function supderAddTask(data) {
  return request({
    url: "/sys/educationalInfo/supderAddTask",
    method: "post",
    data,
  });
}
/**
 * 清除任务标识
 * @param {*} data
 * @returns
 */
export function supderClearTask(data) {
  return request({
    url: "/sys/educationalInfo/supderClearTask",
    method: "post",
    data,
  });
}

// 退款详情列表
export function queryRefunds(currentPage, pageSize, data) {
  let taskId = data.taskId;
  // "/orderRefund/queryRefunds/"+taskId,
  return request({
    url:
      "/sys/orderRefund/queryRefunds/" +
      taskId +
      "?currentPage=" +
      currentPage +
      "&pageSize=" +
      pageSize,
    headers: {
      "Content-Type": "application/json",
    },
    method: "post",

    data,
  });
}

//确认已经退款
export function comfirmRefunds(data) {
  return request({
    url: "/sys/orderRefund/comfirmRefunds",
    method: "post",
    data,
  });
}

/**
 * 获取任务导入进度列表
 * @param {*} id//任务列表ID
 * @returns
 */
export function uploadTaskList(id) {
  return request({
    url: "/sys/uploadTask/list?taskId=" + id,
    method: "post",
  });
}

/**
 * 采集提醒推送
 * @param {*} taskId//任务ID
 * @returns
 */
export function smsRemind(taskId) {
  return request({
    url: "/sys/taskInfo/smsRemind?taskId=" + taskId,
    method: "get",
  });
}

/**
 * 上传成教
 *
 * @param {*} adultID//任务ID data//文件
 * @returns
 */
export function uploadAdult(adultID, data) {
  return request({
    url: "/sys/taskInfo/uploadAdult?id=" + adultID,
    method: "post",
    data,
  });
}

/**
 * 获取i豆数量配置
 *
 * @param {string} code //任务编码
 * @returns
 */
export function getParamByCode(code) {
  return request({
    url: `/sys/sysParam/getParamByCode/${code}`,
    method: "get",
  });
}
